export const salesData = [
    "$0 - $500K",
    "$501K - $1MM",
    "$1MM - $5MM",
    "$5MM - $20MM",
    "$20MM - $50MM",
    "$50MM+"
];
